import { gql } from 'apollo-angular';

const EXPIRE_RFP_TODAY = gql`
  mutation expireRfpToday($id: Long!) {
    expireRfpToday(expireRfpTodayRequest: { id: $id }) {
      id
      status
    }
  }
`;

export default EXPIRE_RFP_TODAY;
